import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-mais-buscados {
  display: flex;
  padding-top: 48px;
}

#carros-eletricos-mais-buscados .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.carros-eletricos-mais-title {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: #000000;
  margin: 0;
  margin-bottom: 23px;
  width: 230px;
}

.carros-eletricos-mais-title b {
  color: #cc0000;
  font-weight: 600!important;
}

.carros-eletricos-mais-cars {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 40px;
  margin-bottom: 40px;
}

.carros-eletricos-mais-cars-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 370px;
  z-index: 1;
}

.carros-eletricos-mais-cars-title {
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  color: #222222;
  margin-bottom: 5px;
}

.carros-eletricos-mais-cars-title b {
  color: #cc0000;
}

.carros-eletricos-mais-subtitle {
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
  color: #767676;
  margin-bottom: 15px;
  width: 90%;
}

.carros-eletricos-mais-cars-img {
  display: flex;
  width: 90%;
}

.carros-eletricos-mais-cars-img img {
  display: flex;
  width: 90%;
  height: 100%;
  object-fit: contain;
  margin: auto;
}

.carros-eletricos-mais-btn {
  padding: 10px 40px;
  width: 225px;
}

.carros-eletricos-mais-buscados-circles-1,
.carros-eletricos-mais-buscados-circles-2 {
  display: none;
  z-index: 0;
}

@media (min-width: 992px) {
  #carros-eletricos-mais-buscados {
    margin-bottom: 0px;
    overflow: hidden;
    padding-top: 72px;
  }

  .carros-eletricos-mais-title {
    font-size: 32px;
    line-height: 32px;
    text-align: center;
    margin-bottom: 61px;
    width: 100%;
  }

  .carros-eletricos-mais-cars {
    flex-direction: row;
    width: 100%;
    gap: 0px;
    justify-content: center;
    margin-bottom: 110px;
  }

  .carros-eletricos-mais-cars-card {
    max-width: 370px;
  }

  .carros-eletricos-mais-cars-title {
    font-size: 28px;
    margin-bottom: 5px;
  }

  .carros-eletricos-mais-subtitle {
    font-size: 16px;
    margin-bottom: 20px;
    width: 100%;
  }

  .carros-eletricos-mais-cars-img {
    display: flex;
    width: 100%;
  }

  .carros-eletricos-mais-cars-img img {
    width: 100%;
    height: 100%;
  }

  .carros-eletricos-mais-btn {
    padding: 10px 50px;
    width: 563px;
    margin-bottom: 30px;
  }

  .carros-eletricos-mais-buscados-circles-1 {
    display: flex;
    position: absolute;
    bottom: 0;
    left: -110px;
    background-image: url('assets/carros-eletricos/circles-mais-buscados-1.png'), url('assets/carros-eletricos/circles-mais-buscados-1.webp');
    width: 265px;
    height: 125px;
    background-repeat: no-repeat;
  }

  .carros-eletricos-mais-buscados-circles-2 {
    display: flex;
    position: absolute;
    bottom: 265px;
    right: -100px;
    background-image: url('assets/carros-eletricos/circles-mais-buscados-2.png'), url('assets/carros-eletricos/circles-mais-buscados-2.webp');
    width: 247px;
    height: 99px;
    background-repeat: no-repeat;
  }
}
`;

export default styles;